import { rootApi } from "../../api/rootApi";

export const lancerApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({

    getLancerAddressApi: builder.mutation({
      query: (params) => {
        return {
          method: "GET",
          url: `/tenant/lancer/qr-address`,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          }
        };
      },
    }),

    getCartonListByProduct: builder.mutation({
      query: (params) => {
        let url = `/tenant/lancer/get-carton-list?`;
        if (params.product_code) url += `product_code=${params.product_code}`;
        if (params.carton_no) url += `carton_no=${params.carton_no}`;

        return {
          method: "GET",
          url: url,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.slug,
          }
        };
      }
    }),



    editAssortment: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/lancer/edit-assortment`,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.slug,
            "Content-Type": "application/json"
          },
          body: params.body,
        };
      },
    }),

    getEditedCartonList: builder.query({
      query: (params) => ({
        url: `/tenant/lancer/fetch-edited-carton-list`,
        method: "GET",
        headers: {
          Authorization: "Bearer " + params.token,
          slug: params.slug,
        }
      })
    }),

    getAllCartonList: builder.query({
      query: (params) => {
        let url = `/tenant/lancer/get-all-carton-list?limit=${params.limit || 10}&offset=${params.offset || 0}`;
        if (params.carton_no) url += `&carton_no=${params.carton_no}`;
        if (params.unit) url += `&unit=${params.unit}`;
        if (params.checkout) url += `&checkout=${params.checkout}`;
        if (params.startDate) url += `&startDate=${params.startDate}`;
        if (params.endDate) url += `&endDate=${params.endDate}`;

        return {
          url: url,
          method: "GET",
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.slug,
          }
        };
      }
    }),

    getDistinctUnits: builder.query({
      query: (params) => ({
        url: `/tenant/lancer/get-distinct-units`,
        method: "GET",
        headers: {
          Authorization: "Bearer " + params.token,
          slug: params.slug,
        }
      })
    }),
  }),
});

export const { useGetLancerAddressApiMutation, useEditAssortmentMutation, useGetCartonListByProductMutation, useGetEditedCartonListQuery, useGetAllCartonListQuery, useGetDistinctUnitsQuery, useLazyGetAllCartonListQuery } = lancerApi;
